/** Sync protocol message types */
export enum YJSMessageType {
  Sync = 0,
  Awareness = 1,
  Auth = 2,
  QueryAwareness = 3,
  /**
   * Tunasong extension — y-protocols reserves 0-3, so 4 is ours. A client leaving an entity's
   * yjs room: the provider sends one on `destroy()` and the relay consumes it by deleting the
   * entity from the connection row's `yjsEntityIds` set, the `DELETE` that matches the `ADD` a
   * registration frame does. It is never relayed on, so no peer should ever see one — but a
   * peer that does must not crash on it. GH #1888.
   */
  RoomLeave = 4,
}

export const YJSMessageTypeName: Record<YJSMessageType, string> = {
  0: 'Sync',
  1: 'Awareness',
  2: 'Auth',
  3: 'QueryAwareness',
  4: 'RoomLeave',
}

export enum YJSSyncType {
  /** SyncStep0 that is the same as SyncStep1, but force a full sync for clients seen before */
  SyncStep0 = 100,
  SyncStep1 = 0,
  SyncStep2 = 1,
  Update = 2,
}

/**
 * Frames on which the relay registers the sender in the entity's yjs room — sent on connect and
 * on every resync interval. See `backend/ws-api/src/ws/yjs.ts` and `@tunasong/ws`'s `yjsRoom`.
 */
export const yjsRoomRegistrationTypes = [YJSSyncType.SyncStep0, YJSSyncType.SyncStep1] as const
